import { atom } from 'recoil';

const gmMapIdState = atom({
    key: 'gmMapId',
    default: null
});

export default gmMapIdState;
